import React from "react";

const CyberDashboard = () => {
  return (
    <div className="min-h-screen bg-gradient-to-r from-red-700 to-blue-800 text-white p-6 md:p-12 lg:p-20 font-sans">
      {/* Header */}
      <div className="text-center mb-12">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold">
          Flexible, top-quality cybersecurity upskilling
        </h1>
        <p className="text-gray-200 mt-3 text-sm md:text-base">
          Unlock an interactive and guided learning experience that combines theory and practice.
        </p>
      </div>

      {/* Grid */}
      <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
        {/* Left Column */}
        <div className="lg:flex-1 flex flex-col gap-6">
          {/* Academy Lab Card */}
          <div className="bg-gradient-to-br from-red-600 via-red-500 to-red-400 p-6 rounded-xl shadow-lg">
            <h3 className="text-lg md:text-xl">🧪 Academy Lab</h3>
            <p className="text-green-400 font-bold">Overview</p>
            <h4 className="mt-2 font-semibold">File Upload Attacks</h4>
            <p>Linux Fundamentals 🐧</p>
            <p>Using Web Proxies</p>
            <h4 className="mt-2 font-semibold">Broken Authentication</h4>
            <p>File Inclusion</p>
            <p>Vulnerability Assessment</p>
          </div>

          {/* Lab Progress Card */}
          <div className="bg-gradient-to-br from-blue-600 via-blue-500 to-blue-400 p-6 rounded-xl shadow-lg">
            <h4 className="font-semibold mb-2">Lab Progress</h4>
            <div className="bg-gray-800 h-3 rounded-full mb-2">
              <div className="h-3 rounded-full bg-green-400 w-3/5 transition-all duration-500"></div>
            </div>
            <div className="bg-gray-800 h-3 rounded-full">
              <div className="h-3 rounded-full bg-blue-400 w-2/5 transition-all duration-500"></div>
            </div>
          </div>
        </div>

        {/* Center Column */}
        <div className="lg:flex-2 flex flex-col gap-6">
          {/* Stats Card */}
          <div className="bg-gradient-to-br from-red-500 via-red-400 to-blue-500 p-6 rounded-xl shadow-lg">
            <div className="flex justify-around text-center">
              <div>
                <h3 className="text-2xl md:text-3xl font-bold">12</h3>
                <p>Assigned</p>
              </div>
              <div>
                <h3 className="text-2xl md:text-3xl font-bold">4/10</h3>
                <p>Machines</p>
              </div>
              <div>
                <h3 className="text-2xl md:text-3xl font-bold">2/2</h3>
                <p>Challenges</p>
              </div>
            </div>
          </div>

          {/* Tasks */}
          {[
            { title: "Broken Authentication", status: "❌ Tier II - Medium" },
            { title: "File Upload Attacks", status: "✅ Tier II - Medium" },
            { title: "JavaScript Deobfuscation", status: "⚪ Tier 0 - Easy" },
          ].map((task) => (
            <div
              key={task.title}
              className="bg-gradient-to-br from-blue-600 via-blue-500 to-red-500 p-6 rounded-xl shadow-lg"
            >
              <h4 className="font-semibold">{task.title}</h4>
              <p>{task.status}</p>
              <button className="mt-2 bg-yellow-400 text-black font-bold px-4 py-2 rounded-lg hover:bg-yellow-300 transition">
                View
              </button>
            </div>
          ))}
        </div>

        {/* Right Column */}
        <div className="lg:flex-1 flex flex-col gap-6">
          {/* Skills Card */}
          <div className="bg-gradient-to-br from-red-500 via-red-400 to-blue-500 p-6 rounded-xl shadow-lg">
            <h4 className="font-semibold mb-2">Skills</h4>
            {["Reversing", "DLL Injection", "Web Assessment"].map((skill) => (
              <div
                key={skill}
                className="bg-purple-600 px-3 py-1 mb-2 inline-block rounded-md font-medium"
              >
                {skill}
              </div>
            ))}
            <button className="mt-2 border border-white px-3 py-1 rounded-md hover:bg-white hover:text-black transition">
              Filter
            </button>
          </div>

          {/* Difficulty Card */}
          <div className="bg-gradient-to-br from-blue-500 via-blue-400 to-red-400 p-6 rounded-xl shadow-lg">
            <h4 className="font-semibold mb-2">Difficulty</h4>
            <p>Very Easy: 1</p>
            <p>Easy: 5</p>
            <p>Medium: 4</p>
            <p>Hard: 3</p>
            <p>Insane: 4</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CyberDashboard;